<template>
  <div class="base-luckdraw" ref="luckdraw">
    <div
      class="lucktable"
      :style="{ transform: rotateAngle, transition: rotateTransition }"
    >
      <div
        class="prize-bg"
        :style="{
          backgroundImage: `url(${mValue.bg || defaultBg})`,
          ...prizeBgStyle
        }"
      ></div>
      <div class="prize">
        <div
          v-for="(item, index) in listValue"
          class="item"
          :style="getRotateAngle(index)"
          :key="index"
        >
          <slot name="item" :item="item"></slot>
        </div>
      </div>
    </div>
    <div
      @click="startTurns"
      class="pointer"
      :style="{
        backgroundImage: `url(${mValue.btn || defaultBtn})`,
        ...pointerStyle
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'BaseLuckdraw',
  props: {
    prizeList: {
      required: true
    },
    turnsNumber: {
      default: 5
    },
    turnsTime: {
      // 转动需要持续的时间(秒)
      default: 5
    },
    draw: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      mValue: undefined,
      listValue: [],
      winningPrize: 0,
      // 开始转动的角度
      startRotateDegree: 0,
      // 设置指针默认指向的位置,现在是默认指向2个扇形之间的边线上
      rotateAngle: 0, //`rotate(30deg)`
      rotateTransition: '',
      pointerStyle: {
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat'
      },
      defaultBtn:
        'https://yxfile.3k.com/2023/03/14/upload_87k2aj5uk73w4f0fr0zsprvi46wzwvxt.png',
      prizeBgStyle: {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      },
      defaultBg:
        'https://yxfile.3k.com/2023/03/13/upload_xoot12tp192hffmz7y5f1y49a0odo1l9.png'
    };
  },
  watch: {
    draw: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.mValue = newVal;
        console.log(oldVal);
      }
    },
    prizeList: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.listValue = newVal;
        console.log('prizeList', oldVal);
      }
    }
  },
  methods: {
    // 根据index计算每一格要旋转的角度的样式
    getRotateAngle(index) {
      const angle =
        (360 / this.prizeList.length) * index + 180 / this.prizeList.length;
      return {
        transform: `rotate(${angle}deg)`
      };
    },
    // 转动起来
    rotate(index) {
      const turnsTime = this.turnsTime;
      const rotateAngle =
        this.startRotateDegree +
        this.turnsNumber * 360 +
        360 -
        (180 / this.prizeList.length + (360 / this.prizeList.length) * index) -
        (this.startRotateDegree % 360);
      this.startRotateDegree = rotateAngle;
      this.rotateAngle = `rotate(${rotateAngle}deg)`;
      this.rotateTransition = `transform ${turnsTime}s cubic-bezier(0.250, 0.460, 0.455, 0.995)`;
      setTimeout(() => {
        this.$emit('end-turns');
      }, turnsTime * 1000 + 500);
    },
    startTurns() {
      this.$emit('start-turns');
    }
  }
};
</script>

<style lang="scss" scoped>
.prize-bg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.base-luckdraw {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 632px;
  height: 632px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.drawTable-name {
  position: absolute;
  left: 0px;
  top: 70px;
  margin: 0 60px;
  width: calc(100% - 120px);
  font-size: 22px;
  text-align: center;
  color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.drawTable-img {
  position: absolute;
  /*要居中就要50% - 宽度 / 2*/
  left: calc(50% - 66px / 2);
  top: 125px;
  width: 66px;
  height: 66px;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.lucktable {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.prize {
  position: absolute;
  left: 25%;
  top: 0;
  width: 50%;
  height: 50%;
  .item {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transform-origin: center bottom;
  }
}
.pointer {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  width: 129px;
  height: 153px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
